var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75045 0.00219955C4.69234 0.0499023 2.73121 0.996919 1.45638 2.55867C-0.689618 5.18765 -0.438713 8.92326 2.0419 11.2762C4.33288 13.4494 7.89463 13.8347 10.6489 12.2074C10.7114 12.1704 10.7679 12.1401 10.7743 12.1401C10.7807 12.1401 11.69 12.9973 12.7949 14.0451C14.1305 15.3115 14.8133 15.9544 14.8322 15.9633C15.0434 16.0627 15.3936 15.957 15.7534 15.6853C15.8514 15.6112 16.5725 14.9285 16.6591 14.8277C16.9538 14.4848 17.0714 14.1346 16.9566 13.9415C16.945 13.922 16.2215 13.2307 14.9164 11.9922C13.8041 10.9367 12.8941 10.0705 12.8941 10.0673C12.8941 10.0641 12.925 10.0112 12.9628 9.94981C14.9601 6.70509 13.7341 2.56464 10.2475 0.780076C9.18003 0.233729 8.00811 -0.0269517 6.75045 0.00219955ZM7.18625 2.19236C9.68053 2.31747 11.6115 4.24169 11.6115 6.60211C11.6115 9.27141 9.13706 11.329 6.34654 10.98C3.77827 10.6588 1.9788 8.39798 2.35074 5.95968C2.69214 3.72158 4.80805 2.07308 7.18625 2.19236Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.af25d285f450c4e179e645601030e67d.svg";
export { ForwardRef as ReactComponent };